// extracted by mini-css-extract-plugin
module.exports = {"researchIdeas":"ResearchIdeas_researchIdeas__3y9oy","topicsCard":"ResearchIdeas_topicsCard__3Jj4V"};